import React from "react";
import { Table } from "react-bootstrap";
import moment from "moment";

import MailingApproveReject from "./MailingApproveReject";
import MailingGenerateUrlButton from "./MailingGenerateUrlButton";

class MailingViewerTable extends React.Component {
  constructor() {
    super();

    this.state = {
      mailings: []
    };
  }
  componentWillMount() {
    this.setState({
      mailings: this.props.video.mailings
    });
  }
  componentWillReceiveProps(props) {
    this.setState({
      mailings: props.video.mailings
    });
  }
  setStatusClass(status) {
    let parsedStatus = status.toLowerCase();
    let classes = {
      pronto: "text-success",
      aprovado: "text-success",
      "em análise": "text-warning",
      "gerando urls": "text-warning",
      rejeitado: "text-danger"
    };
    return classes[parsedStatus];
  }
  render() {
    const { video } = this.props;
    return (
      <Table striped bordered>
        <thead>
          <tr>
            <th class="col-md-2">ID</th>
            <th class="col-md-2">Nome</th>
            <th class="col-md-2">Data de Envio</th>
            <th class="col-md-1">Download</th>
            <th class="col-md-2">Status</th>
            <th class="col-md-2" />
            <th class="col-md-2">Observações</th>
            <th class="col-md-1" />
          </tr>
        </thead>
        <tbody>
          {this.state.mailings.map((mailing, index) => (
            <tr key={index}>
              <td>{mailing.id}</td>
              <td>{mailing.name}</td>
              <td>
                {moment(mailing.created_at).format("DD/MM/YYYY [às] HH:mm:ss")}
              </td>
              <td>
                <a
                  className="btn btn-link btn-xs"
                  href={mailing.data_path}
                  download
                >
                  Download
                </a>
              </td>
              <td>
                <span className={this.setStatusClass(mailing.status)}>
                  {mailing.status}
                </span>
              </td>
              <td>
                <MailingApproveReject mailing={mailing} video={video} />
              </td>
              <td>{mailing.rejection_motive}</td>
              <td>
                <MailingGenerateUrlButton mailing={mailing} video={video} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }
}

export default MailingViewerTable;



// WEBPACK FOOTER //
// ./src/components/pages/Mailing/MailingManagerTable.js